import React, { lazy, useEffect, useState } from "react";
import LazyComponent from "components/Lazy/LazyComponent";
import { lazyWithPreload } from "react-lazy-with-preload";

const Header = lazyWithPreload(() => import("layouts/Header/Header"));
const Hero = lazyWithPreload(() => import("components/Hero/Hero"));
const HeroNew = lazyWithPreload(() => import("components/HeroNew/HeroNew"));
const Content = lazy(() => import("components/Content/Content"));
const Carousel = lazy(() => import("components/Carousel/Carousel"));
const Coupon = lazy(() => import("components/Coupon/Coupon"));
const Footer = lazy(() => import("layouts/Footer/Footer"));

const Layout: React.FC = () => {
  const [showHeroV2, setShowHeroV2] = useState(false);

  useEffect(() => {
    const value = window?.listicle_v2?.page_settings?.show_hero_v2;
    setShowHeroV2(!!value);

    Header.preload();
    value ? HeroNew.preload() : Hero.preload();
  }, []);

  return (
    <>
      <Header />
      <main>
        {showHeroV2 ? <HeroNew /> : <Hero />}
        <LazyComponent Component={Content} rootMargin={400} />
        <LazyComponent Component={Carousel} rootMargin={200} />
        <LazyComponent Component={Coupon} rootMargin={400} />
      </main>
      <LazyComponent Component={Footer} rootMargin={400} />
    </>
  );
};

export default Layout;
